export const options: ISelectOption<string>[] = [
    {
        label: 'No',
        value: '0',
    },
    {
        label: 'Yes',
        value: '1',
    },
];
